export const arrowLeftLightIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M18.401 24a.5.5 0 0 1-.331-.125L5.495 12.748a1.002 1.002 0 0 1-.001-1.496L18.069.125a.5.5 0 0 1 .707.044.5.5 0 0 1-.043.705L6.157 12l12.575 11.125a.501.501 0 0 1-.331.875"/></svg>`,
    name: 'arrow-left-light'
};